import { createSlice } from '@reduxjs/toolkit';

import { resetStoresAction } from 'common/actions/common';

type RecoveryState = {
  isFetching: boolean;
  isHashValid: boolean;
  message: string;
  error: string;
};

export type RecoveryPartialState = {
  recovery: RecoveryState;
};

const defaultState: RecoveryState = {
  isFetching: false,
  isHashValid: false,
  message: '',
  error: '',
};

const setFetching = (state: RecoveryState): RecoveryState => ({
  ...state,
  isFetching: true,
});

const handleError = (
  state: RecoveryState,
  { payload: error },
): RecoveryState => ({
  ...state,
  isFetching: false,
  message: '',
  error,
});

const recovery = createSlice({
  name: 'recovery',
  initialState: defaultState,
  reducers: {
    recoveryHashCheckAction: setFetching,
    recoveryEmailSendAction: setFetching,
    recoveryChangePasswordAction: setFetching,
    recoveryHashCheckFailedAction: handleError,
    recoveryEmailSendFailedAction: handleError,
    recoveryChangePasswordFailedAction: handleError,
    recoveryHashCheckSuccessAction: (state) => ({
      ...state,
      isFetching: false,
      isHashValid: true,
    }),
    recoveryEmailSendSuccessAction: (state, { payload }) => ({
      ...state,
      isFetching: false,
      message: payload,
      error: '',
    }),
    recoveryChangePasswordSuccessAction: () => defaultState,
    recoveryResetPageAction: () => defaultState,
  },
  extraReducers: (builder) =>
    builder.addCase(resetStoresAction, () => defaultState),
});

export const {
  recoveryHashCheckAction,
  recoveryEmailSendAction,
  recoveryChangePasswordAction,
  recoveryHashCheckFailedAction,
  recoveryEmailSendFailedAction,
  recoveryChangePasswordFailedAction,
  recoveryHashCheckSuccessAction,
  recoveryEmailSendSuccessAction,
  recoveryChangePasswordSuccessAction,
  recoveryResetPageAction,
} = recovery.actions;

export default recovery.reducer;
